export const es = {
  common: {
    language: "Idioma",
    spanish: "Español",
    english: "English",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    cancel: "Cancelar",
    delete: "Eliminar",
    save: "Guardar",
    saving: "Guardando...",
    actions: "Acciones",
  },
  auth: {
    title: "Sistema NFC Magma",
    subtitle: "Sistema de captura de datos para especialistas en fibra de carbono",
    email: "Correo electrónico",
    password: "Contraseña",
    fullName: "Nombre completo",
    operatorArea: "Área de Trabajo",
    selectArea: "Seleccione su área",
    areas: {
      corte_plotter: "Corte / Plotter",
      laminador: "Laminador",
      taller: "Taller",
      generico: "Genérico / Esporádico",
    },
    signIn: "Iniciar Sesión",
    signUp: "Registrarse",
    noAccount: "¿No tienes una cuenta?",
    hasAccount: "¿Ya tienes una cuenta?",
    signInHere: "Inicia sesión aquí",
    signUpHere: "Regístrate aquí",
    emailRequired: "El correo electrónico es requerido",
    emailInvalid: "Correo electrónico inválido",
    passwordRequired: "La contraseña es requerida",
    passwordMin: "La contraseña debe tener al menos 6 caracteres",
    nameRequired: "El nombre es requerido",
    areaRequired: "Debe seleccionar un área de trabajo",
  },
  filters: {
    selectArea: "Filtrar por área",
    allAreas: "Todas las áreas",
  },
  operatorAssignment: {
    title: "Asignación de Operarios",
    subtitle: "Distribución y estado actual de operarios por área en tiempo real",
    totalOperators: "Total Operarios",
    activeOperators: "Operarios Activos",
    inactiveOperators: "Operarios Inactivos",
    registered: "Registrados",
    working: "Trabajando",
    available: "Disponible",
    distributionByArea: "Distribución por Área",
    areaStatistics: "Estadísticas por Área",
    operatorList: "Lista de Operarios",
    operators: "operarios",
    active: "activos",
    inactive: "inactivos",
    order: "Orden",
    noOperators: "No hay operarios registrados",
    noShift: "Sin turno",
    shifts: {
      morning: "Mañana",
      afternoon: "Tarde",
      night: "Noche",
    },
  },
  nav: {
    dashboard: "Dashboard",
    workOrders: "Órdenes de Trabajo",
    nfcCaptures: "Capturas NFC",
    analytics: "Análisis",
    integrations: "Integraciones",
    settings: "Configuración",
  },
  dashboard: {
    welcome: "Bienvenido al Sistema NFC Magma",
    subtitle: "Datos de producción en tiempo real de fabricación de fibra de carbono",
    nfcToday: "Capturas NFC Hoy",
    activeDevices: "Dispositivos Activos",
    operators: "Operadores",
    successRate: "Tasa de Éxito",
    dailyCaptures: "Capturas NFC Diarias",
    productionFlow: "Flujo de Datos de Producción",
    fromYesterday: "desde ayer",
    allOnline: "Todos en línea",
    shiftsActive: "turnos activos",
    thisWeek: "esta semana",
    activeOrders: "Órdenes Activas",
    inProgressProcesses: "Procesos en Curso",
    activeOperators: "Operarios Trabajando",
    completionRate: "Tasa de Finalización",
    inProgress: "En progreso",
    noActive: "Sin actividad",
    active: "Activos",
    workingNow: "Trabajando ahora",
    today: "Hoy",
    refresh: "Actualizar",
    alerts: "Alertas y Problemas",
    noAlerts: "No hay alertas activas",
    realtimeEvolution: "Evolución en Tiempo Real",
    performanceMetrics: "Métricas de Rendimiento",
    configure: "Configurar",
    dashboardSettings: "Configuración del Dashboard",
    dashboardSettingsDesc: "Personaliza tu dashboard, elige widgets y guarda vistas",
    selectView: "Seleccionar Vista",
    manageViews: "Gestionar Vistas",
    setAsDefault: "Establecer por defecto",
    selectWidgets: "Seleccionar Widgets",
    saveNewView: "Guardar como Nueva Vista",
    viewName: "Nombre de la vista",
    saveView: "Guardar Vista",
    editMode: "Editar",
    exitEditMode: "Salir",
    editModeDesc: "Modo de edición activado: arrastra los widgets para reorganizarlos",
  },
  nfcCaptures: {
    title: "Capturas NFC",
    subtitle: "Recolección de datos móviles en tiempo real desde la planta de producción",
    newSession: "Nueva Sesión de Captura",
    loading: "Cargando capturas...",
    noCaptures: "No hay capturas NFC",
    noCapturesDesc: "Comienza una nueva sesión de captura para ver los datos aquí",
    startFirst: "Iniciar Primera Captura",
    viewDetails: "Ver Detalles",
    device: "Dispositivo",
    operator: "Operador",
    location: "Ubicación",
    dataPoints: "Puntos de Datos",
    unknown: "Desconocido",
    status: {
      completed: "Completado",
      processing: "Procesando",
      error: "Error",
    },
  },
  nfcTags: {
    title: "Administración de Etiquetas NFC",
    subtitle: "Gestiona el inventario de etiquetas NFC físicas",
    register: "Registrar Etiqueta",
    registerTag: "Registrar Nueva Etiqueta NFC",
    editTag: "Editar Etiqueta NFC",
    registerDescription: "Registra una nueva etiqueta NFC en el sistema",
    editDescription: "Modifica la asignación y estado de la etiqueta",
    tagUID: "UID de Etiqueta",
    tagLabel: "Etiqueta/Nombre",
    workOrder: "Orden de Trabajo",
    process: "Proceso",
    location: "Ubicación",
    status: "Estado",
    notes: "Notas",
    notesPlaceholder: "Información adicional sobre la etiqueta...",
    selectWorkOrder: "Seleccionar...",
    selectProcess: "Seleccionar...",
    none: "Ninguna",
    statusActive: "Activa",
    statusInactive: "Inactiva",
    statusDamaged: "Dañada",
    statusLost: "Perdida",
    totalTags: "Total",
    activeTags: "Activas",
    inactiveTags: "Inactivas",
    damagedTags: "Dañadas",
    filterByStatus: "Filtrar por estado",
    allStatus: "Todos",
    assignment: "Asignación",
    lastScan: "Último Escaneo",
    noTags: "No hay etiquetas registradas",
    noTagsDesc: "Comienza registrando tu primera etiqueta NFC",
    created: "Etiqueta registrada",
    updated: "Etiqueta actualizada",
    deleted: "Etiqueta eliminada",
    confirmDelete: "¿Eliminar esta etiqueta?",
    unknown: "Desconocido",
    printLabel: "Imprimir Etiqueta",
  },
  analytics: {
    title: "Análisis",
    subtitle: "Métricas y reportes del sistema",
    performanceTrends: "Tendencias de Rendimiento",
    revenueOverview: "Vista General de Ingresos",
  },
  operatorView: {
    title: "Seleccione Trabajo:",
    myTasks: "Mis Tareas",
    pendingWorks: "Trabajos Pendientes",
    nfcScan: "Escanear NFC",
    waitingTag: "Esperando Etiqueta",
    scanNow: "Escanear Ahora",
    noAssignedTasks: "No tienes tareas asignadas",
    noAssignedTasksDesc: "Contacta a tu supervisor para que te asigne trabajos",
    startProcess: "Iniciar Proceso",
    processStarted: "Proceso iniciado",
    nfcNotSupported: "NFC no soportado en este dispositivo",
    nfcAndroidOnly: "Disponible solo en Android con Chrome",
    approachTag: "Acerca tu dispositivo a una etiqueta NFC...",
    tagDetected: "¡Etiqueta detectada!",
    writeTag: "Escribir NFC",
  },
  workOrders: {
    title: "Órdenes de Trabajo",
    subtitle: "Gestión de órdenes de producción",
    newOrder: "Nueva Orden",
    orderNumber: "Número de Orden",
    productName: "Producto",
    customer: "Cliente",
    quantity: "Cantidad",
    priority: "Prioridad",
    status: "Estado",
    createdAt: "Creada",
    startedAt: "Iniciada",
    completedAt: "Completada",
    actions: "Acciones",
    viewDetails: "Ver Detalles",
    noOrders: "No hay órdenes de trabajo",
    noOrdersDescription: "Comienza creando una nueva orden de trabajo",
    createOrder: "Crear Orden",
    editOrder: "Editar Orden",
    orderDetails: "Detalles de la Orden",
    processes: "Procesos",
    addProcess: "Agregar Proceso",
    selectProcess: "Seleccionar Proceso",
    selectOperator: "Seleccionar Operador",
    startProcess: "Iniciar Proceso",
    completeProcess: "Completar Proceso",
    pauseProcess: "Pausar Proceso",
    resumeProcess: "Reanudar Proceso",
    addPause: "Agregar Pausa",
    pauseReason: "Motivo de Pausa",
    duration: "Duración",
    notes: "Notas",
    processData: "Datos del Proceso",
    operator: "Operador",
  },
  processes: {
    material_arrival: "Llegada del material",
    freezer_storage: "Registro en congeladores",
    material_cutting: "Corte del material",
    mold_selection: "Selección del molde",
    material_layup: "Aplicación de material",
    vacuum_bagging: "Vacío de la pieza",
    autoclave_curing: "Curado en autoclave",
    demolding: "Desmoldeo",
    quality_inspection: "Inspección de calidad",
    cutting_workshop: "Taller de corte",
    packaging: "Embalaje",
    dispatch: "Despacho",
  },
  processFields: {
    freezer_number: "Número de Congelador",
    temperature: "Temperatura",
    cutting_method: "Método de Corte",
    mold_id: "ID del Molde",
    mold_type: "Tipo de Molde",
    layers: "Capas",
    material_type: "Tipo de Material",
    vacuum_pressure: "Presión de Vacío",
    autoclave_number: "Número de Autoclave",
    pressure: "Presión",
    duration: "Duración",
    passed: "Aprobado",
    defects: "Defectos",
    packaging_type: "Tipo de Embalaje",
    destination: "Destino",
    tracking_number: "Número de Seguimiento",
  },
  statuses: {
    pending: "Pendiente",
    in_progress: "En Progreso",
    completed: "Completado",
    cancelled: "Cancelado",
    paused: "Pausado",
  },
  shifts: {
    morning: "Mañana",
    afternoon: "Tarde",
    night: "Noche",
  },
  experienceLevels: {
    junior: "Junior",
    mid: "Intermedio",
    senior: "Senior",
    expert: "Experto",
  },
  integrations: {
    title: "Integraciones",
    subtitle: "Conecta el sistema NFC Magma con plataformas CRM y ERP",
    connect: "Conectar",
    available: "Disponible",
    comingSoon: "Próximamente",
    salesforce: {
      name: "Salesforce CRM",
      description: "Sincroniza datos de clientes y pipelines de ventas",
    },
    sap: {
      name: "SAP ERP",
      description: "Conecta con planificación de recursos empresariales",
    },
    hubspot: {
      name: "HubSpot",
      description: "Automatización de marketing y CRM",
    },
    netsuite: {
      name: "Oracle NetSuite",
      description: "Suite de gestión empresarial en la nube",
    },
    dynamics: {
      name: "Microsoft Dynamics",
      description: "Aplicaciones empresariales integrales",
    },
    zoho: {
      name: "Zoho CRM",
      description: "Plataforma de ventas y marketing",
    },
  },
  settings: {
    title: "Configuración",
    subtitle: "Configura las preferencias de tu sistema NFC Magma",
    general: "General",
    preferences: "Preferencias",
    workspaceName: "Nombre del Espacio de Trabajo",
    emailNotifications: "Notificaciones por Email",
    realtimeUpdates: "Actualizaciones en Tiempo Real",
    realtimeUpdatesDesc: "Actualiza automáticamente los datos de fuentes conectadas",
    emailAlerts: "Alertas por Email",
    emailAlertsDesc: "Recibe notificaciones sobre eventos del sistema",
    dataExport: "Exportación de Datos",
    dataExportDesc: "Permitir exportaciones automáticas de datos",
    customKPIs: "KPIs Personalizados",
    addNewKPI: "Agregar Nuevo KPI",
    metric: "Métrica",
    selectMetric: "Seleccionar métrica",
    condition: "Condición",
    greaterThan: "Mayor que",
    lessThan: "Menor que",
    equalTo: "Igual a",
    threshold: "Umbral",
    notifications: "Notificaciones",
    add: "Agregar",
    noKPIsConfigured: "No hay KPIs configurados todavía",
    kpiAdded: "KPI agregado exitosamente",
    kpiUpdated: "KPI actualizado exitosamente",
    kpiDeleted: "KPI eliminado exitosamente",
    errorLoadingKPIs: "Error al cargar KPIs",
    errorAddingKPI: "Error al agregar KPI",
    errorUpdatingKPI: "Error al actualizar KPI",
    errorDeletingKPI: "Error al eliminar KPI",
    success: "Éxito",
    error: "Error",
    cancel: "Cancelar",
    saveChanges: "Guardar Cambios",
  },
  sidebar: {
    nfcSystem: "Sistema de Captura de Datos NFC",
    dashboard: "Dashboard",
    operatorView: "Vista Operario",
    operatorAssignment: "Asignación de Operarios",
    registerUser: "Registrar Usuario",
    userManagement: "Gestión de Usuarios",
    qrTraceability: "Trazabilidad QR",
    nfcCaptures: "Capturas NFC",
    nfcTagsAdmin: "Admin. Etiquetas NFC",
    analytics: "Analíticas",
    integrations: "Integraciones",
    settings: "Configuración",
    workOrders: "Órdenes de Trabajo",
    tasks: "Tareas",
    nfcReady: "NFC Listo",
    mobileEnabled: "Captura móvil habilitada",
  },
  userManagement: {
    title: "Gestión de Usuarios",
    subtitle: "Administrar roles y permisos de usuarios del sistema",
    totalUsers: "Total Usuarios",
    supervisors: "Supervisores",
    operators: "Operarios",
    userList: "Lista de Usuarios",
    name: "Nombre",
    employeeId: "ID Empleado",
    area: "Área",
    shift: "Turno",
    role: "Rol",
    actions: "Acciones",
    noUsers: "No hay usuarios registrados",
    editRole: "Editar Rol de Usuario",
    editRoleDescription: "Cambiar el rol y permisos del usuario",
    newRole: "Nuevo Rol",
    roleOperator: "Operario",
    roleSupervisor: "Supervisor",
    roleAdmin: "Administrador",
    save: "Guardar",
    saving: "Guardando...",
    roleUpdated: "Rol actualizado exitosamente",
    roleUpdateError: "Error al actualizar rol",
    noArea: "Sin área",
    noShift: "Sin turno",
    status: "Estado",
    active: "Activo",
    inactive: "Inactivo",
    userActivated: "Usuario activado exitosamente",
    userDeactivated: "Usuario desactivado exitosamente",
    statusUpdateError: "Error al actualizar estado",
    auditHistory: "Historial de Auditoría",
    date: "Fecha",
    changedBy: "Modificado por",
    affectedUser: "Usuario Afectado",
    action: "Acción",
    changes: "Cambios",
    created: "Creado",
    updated: "Actualizado",
    deleted: "Eliminado",
    noAuditLogs: "No hay registros de auditoría",
  },
  header: {
    profile: "Perfil",
    logout: "Cerrar Sesión",
  },
  billing: {
    title: "Facturación",
    dashboard: "Panel de Facturación",
    invoices: "Facturas",
    newInvoice: "Nueva Factura",
    editInvoice: "Editar Factura",
    customers: "Clientes Facturación",
    suppliers: "Proveedores",
    articles: "Artículos",
    deliveryNotes: "Albaranes",
    supplierOrders: "Pedidos Proveedores",
    settings: "Configuración Facturación",
    status: {
      draft: "Borrador",
      issued: "Emitida",
      sent: "Enviada",
      paid: "Cobrada",
      partial: "Parcial",
      cancelled: "Anulada",
      overdue: "Vencida",
      rectified: "Rectificada",
    },
    fields: {
      invoiceNumber: "Número de Factura",
      issueDate: "Fecha Emisión",
      dueDate: "Fecha Vencimiento",
      subtotal: "Subtotal",
      tax: "IVA",
      total: "Total",
      customer: "Cliente",
      notes: "Notas",
      paymentMethod: "Método de Pago",
      reference: "Referencia",
    },
    actions: {
      create: "Crear Factura",
      send: "Enviar",
      download: "Descargar PDF",
      duplicate: "Duplicar",
      markPaid: "Marcar como Cobrada",
      cancel: "Anular",
    },
    noInvoices: "No hay facturas",
    noInvoicesDesc: "Comienza creando tu primera factura",
  },
  timeTracking: {
    title: "Fichaje",
    subtitle: "Registro horario obligatorio (RDL 8/2019)",
    admin: "Fichaje (Admin)",
    state: "Estado",
    now: "Ahora",
    clockIn: "Entrada",
    clockOut: "Salida",
    breakStart: "Inicio Pausa",
    breakEnd: "Fin Pausa",
    currentState: {
      working: "Trabajando",
      onBreak: "En pausa",
      off: "Fuera",
      notStarted: "No iniciado",
    },
    buttons: {
      clockIn: "Fichar entrada",
      clockOut: "Fichar salida",
      startBreak: "Iniciar pausa",
      resumeWork: "Reanudar tras pausa",
    },
    nfc: {
      personalNfc: "Fichaje rápido por NFC personal",
      usbReaderReady: "Lector USB listo",
      scanMobile: "Escanear con NFC móvil",
      connectReader: "Conecta un lector USB NFC o usa el móvil",
      chipNotRegistered: "Chip no registrado. Pídele a un admin que lo asigne en Etiquetas NFC.",
      chipNotAssigned: "Chip no asignado a ningún usuario.",
    },
    messages: {
      eventRegistered: "registrada",
      errorRegistering: "Error registrando fichaje",
      errorNfc: "Error NFC fichaje",
    },
    hoursToday: "Horas hoy",
    hoursWeek: "Horas semana",
    summary: "Resumen",
    history: "Historial",
    events: "Eventos",
    noEvents: "Sin eventos hoy",
    todayEvents: "Eventos de hoy",
    selectEmployee: "Seleccionar empleado",
    allEmployees: "Todos los empleados",
    exportReport: "Exportar Informe",
    dateRange: "Rango de fechas",
    overtime: "Horas extra",
    regularHours: "Horas regulares",
  },
  accounting: {
    title: "Contabilidad",
    chartOfAccounts: "Plan Contable",
    journalEntries: "Libro Diario",
    generalLedger: "Libro Mayor",
    trialBalance: "Balance de Comprobación",
    status: {
      draft: "Borrador",
      posted: "Contabilizado",
      reversed: "Anulado",
    },
    fields: {
      entryNumber: "Número de Asiento",
      entryDate: "Fecha",
      description: "Descripción",
      debit: "Debe",
      credit: "Haber",
      account: "Cuenta",
      balance: "Saldo",
      period: "Período",
    },
    actions: {
      newEntry: "Nuevo Asiento",
      post: "Contabilizar",
      reverse: "Anular",
      export: "Exportar",
    },
    noEntries: "No hay asientos",
    noEntriesDesc: "Comienza creando un nuevo asiento contable",
  },
  payroll: {
    title: "Nóminas",
    admin: "Gestión Nóminas",
    myPayslips: "Mis Nóminas",
    upload: "Subir Nómina",
    download: "Descargar",
    sign: "Firmar",
    period: "Período",
    employee: "Empleado",
    status: {
      pending: "Pendiente",
      signed: "Firmada",
      rejected: "Rechazada",
      viewed: "Vista",
    },
    noPayslips: "No hay nóminas",
    noPayslipsDesc: "Las nóminas aparecerán aquí cuando estén disponibles",
    signatureRequired: "Se requiere firma",
    alreadySigned: "Ya firmada",
    fields: {
      grossSalary: "Salario Bruto",
      netSalary: "Salario Neto",
      deductions: "Deducciones",
      uploadDate: "Fecha de Subida",
      signDate: "Fecha de Firma",
    },
  },
  ai: {
    assistant: "Asistente IA",
    title: "Asistente Athenea",
    placeholder: "Escribe tu pregunta...",
    thinking: "Pensando...",
    typing: "Escribiendo...",
    clearChat: "Limpiar chat",
    newChat: "Nueva conversación",
    suggestions: "Sugerencias",
    online: "En línea",
    offline: "Desactivado",
    greeting: "¡Hola! Soy tu asistente de IA para Athenea. Puedo ayudarte con:",
    capabilities: {
      analyzeProduction: "Analizar datos de producción",
      answerQuestions: "Responder preguntas sobre el sistema",
      suggestOptimizations: "Sugerir optimizaciones",
      searchData: "Buscar información",
    },
    error: "Lo siento, hubo un error. Intenta de nuevo.",
    disabled: "La IA está deshabilitada. Contacta al administrador.",
    rateLimit: "Demasiadas solicitudes. Espera un momento.",
  },
  sidebarSections: {
    dashboard: "Dashboard",
    operations: "Operaciones",
    production: "Producción",
    design: "Diseño & CNC",
    inventory: "Inventario",
    commercial: "Gestión Comercial",
    quality: "Calidad & Trazabilidad",
    billing: "Facturación",
    purchases: "Compras",
    legal: "Legal & Compliance",
    system: "Sistema",
    admin: "Administración",
  },
  sidebarItems: {
    executiveDashboard: "Dashboard Ejecutivo",
    myWork: "Mi Trabajo",
    personal: "Personal",
    shiftManagement: "Gestión de Turnos",
    timeTracking: "Fichaje",
    timeTrackingAdmin: "Fichaje (Admin)",
    myPayslips: "Mis Nóminas",
    tasks: "Tareas",
    processes: "Procesos",
    products: "Productos",
    molds: "Moldes",
    machines: "Máquinas",
    autoclaveCycles: "Ciclos Autoclave",
    recipes: "Recetas",
    plybooks: "Plybooks",
    schedule: "Programación",
    flowSimulation: "Simulación Flujo",
    workTypes: "Tipos de Trabajo",
    designProjects: "Proyectos Diseño",
    cncLibrary: "Biblioteca CNC",
    masters: "Masters",
    generalInventory: "Inventario General",
    plotterCuts: "Corte Plotter",
    freezerControl: "Control Congelador",
    workshopCutting: "Corte Taller",
    tools: "Herramientas",
    labels: "Etiquetas",
    customers: "Clientes",
    projects: "Proyectos",
    budgets: "Presupuestos",
    purchaseOrders: "Pedidos (PO)",
    quotations: "Cotizaciones",
    events: "Eventos",
    news: "Noticias",
    qualityControl: "Control de Calidad",
    traceability: "Trazabilidad",
    billingPanel: "Panel Facturación",
    invoices: "Facturas",
    deliveryNotes: "Albaranes",
    articles: "Artículos",
    supplierOrders: "Pedidos Proveedores",
    suppliers: "Proveedores",
    billingCustomers: "Clientes Facturación",
    chartOfAccounts: "Plan Contable",
    journalEntries: "Libro Diario",
    generalLedger: "Libro Mayor",
    billingSettings: "Config. Facturación",
    trialBalance: "Balance",
    expenses: "Gastos",
    legalDocuments: "Documentación Legal",
    compliance: "Compliance INDRA",
    requirements: "Gestión Requisitos",
    riskPrevention: "Prevención Riesgos",
    reports: "Reportes",
    traceabilityHistory: "Trazabilidad",
    supportTickets: "Tickets",
    nfcTagsAdmin: "Admin. Etiquetas NFC",
    payrollAdmin: "Gestión Nóminas",
  },
  quotations: {
    title: "Sistema de Cotización",
    subtitle: "Perseo - Cotizaciones profesionales para Magma Composites",
    fullscreen: "Pantalla completa",
    newWindow: "Nueva ventana",
    back: "Volver",
    recentFiles: "Archivos Recientes",
    noFiles: "Los archivos generados aparecerán aquí",
  },
  freezer: {
    title: "Control de Congeladores",
    materialsOutside: "Materiales Fuera",
    temperatures: "Temperaturas",
    totalOutside: "Total Fuera",
    critical: "Críticos",
    warning: "Advertencia",
    ok: "OK",
    returnToFreezer: "Guardar en congelador",
    timeRemaining: "Tiempo restante",
    expired: "Expirado",
    registerTemp: "Registrar Temperatura",
    freezerStatus: "Estado de Congeladores",
    tempHistory: "Historial de Temperaturas",
    outOfRange: "Fuera de Rango",
    shiftStart: "Inicio de turno",
    shiftEnd: "Fin de turno",
  },
};
